var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeImprovement10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09924 6.27863H20.1612C20.6917 6.27863 21.2004 6.48934 21.5754 6.86441C21.9505 7.23948 22.1612 7.74819 22.1612 8.27863V8.43763C22.1612 9.43134 21.9655 10.4153 21.5852 11.3334C21.205 12.2515 20.6476 13.0856 19.9449 13.7883C19.2423 14.491 18.4081 15.0483 17.49 15.4286C16.5719 15.8089 15.588 16.0046 14.5942 16.0046H11.6662C9.65935 16.0046 7.73465 15.2074 6.31557 13.7883C4.89648 12.3692 4.09924 10.4445 4.09924 8.43763V8.27863C4.09924 7.74819 4.30996 7.23948 4.68503 6.86441C5.0601 6.48934 5.56881 6.27863 6.09924 6.27863V6.27863Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1263 6.27861V2.77161C13.1269 2.57007 13.0879 2.37039 13.0113 2.18396C12.9348 1.99753 12.8223 1.82801 12.6802 1.68508C12.5381 1.54216 12.3692 1.42864 12.1832 1.351C11.9973 1.27336 11.7978 1.23313 11.5963 1.2326H11.5903C11.3884 1.2326 11.1885 1.27245 11.0021 1.34985C10.8156 1.42725 10.6463 1.54069 10.5038 1.68367C10.3613 1.82664 10.2484 1.99634 10.1716 2.18303C10.0948 2.36972 10.0556 2.56974 10.0563 2.77161",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1261 16.0036V21.5036C13.1261 22.0891 13.3586 22.6505 13.7725 23.0646C14.1863 23.4786 14.7477 23.7114 15.3331 23.7116C15.9186 23.7114 16.4801 23.4787 16.8941 23.0646C17.3081 22.6506 17.5408 22.0891 17.5411 21.5036V20.5716C17.5411 19.9749 17.7781 19.4026 18.2001 18.9806C18.6221 18.5587 19.1944 18.3216 19.7911 18.3216V18.3216",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88318 20.9224C6.84783 21.534 6.58 22.1088 6.13454 22.5293C5.68909 22.9497 5.09973 23.1839 4.48719 23.1839C3.87464 23.1839 3.28528 22.9497 2.83983 22.5293C2.39437 22.1088 2.12654 21.534 2.09119 20.9224C2.09119 19.5994 4.49119 16.1314 4.49119 16.1314C4.49119 16.1314 6.88318 19.5994 6.88318 20.9224Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.126099 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImprovement10);
export default __webpack_public_path__ + "static/media/home-improvement-10.e06206f534b74460423dd5987b981e5e.svg";
export { ForwardRef as ReactComponent };